module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n                            " + _vm._s(_vm.flashMessage) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "paddi_class_colm"
  }, [_c('h4', [_vm._v("Trip Location")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("City Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.cityId),
      expression: "trip.cityId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "cityId",
      "disabled": _vm.isCityDisable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.getCityId($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select City Name")]), _vm._v(" "), _vm._l((_vm.cities), function(cityId) {
    return _c('option', {
      domProps: {
        "value": cityId.id,
        "selected": cityId && _vm.trip.cityId && cityId.id === _vm.trip.cityId
      }
    }, [_vm._v(_vm._s(cityId.name) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.transportPoint),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transport Point")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.tId),
      expression: "trip.tId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "transportPoint",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "tId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Transport Point")]), _vm._v(" "), _vm._l((_vm.transferListData), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item._id,
        "selected": item && _vm.trip.tId && _vm.trip.tId === item._id
      }
    }, [_vm._v("\n                                            " + _vm._s(item.transportName) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "transportPoint",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                            Segregation Plant is a required field\n                                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.segregationOrDumpYard),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Segregation Plant / Dump Yard")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.SpDyId),
      expression: "trip.SpDyId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "segregationOrDumpYard"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "SpDyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Segregation Plant / Dump Yard")]), _vm._v(" "), _vm._l((_vm.segDyData), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item._id,
        "selected": item.id && _vm.trip.SpDyId && item.id === _vm.trip.SpDyId
      }
    }, [_vm._v("\n                                            " + _vm._s(item.plantName) + " - " + _vm._s(item.name) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "segregationOrDumpYard",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Dump Yard is a required field")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "paddi_class_colm"
  }, [_c('h4', [_vm._v("Vehicle & Driver")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicle),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.vehicleId),
      expression: "trip.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "vehicle"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id,
        "selected": item && _vm.trip.vehicleId && item.id === _vm.trip.vehicleId
      }
    }, [_vm._v("\n                                            " + _vm._s(item.name) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicle",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driver),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.driverId),
      expression: "trip.driverId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "driver"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "driverId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Driver")]), _vm._v(" "), _vm._l((_vm.driver_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id,
        "selected": item && _vm.trip.driverId && item.id === _vm.trip.driverId
      }
    }, [_vm._v("\n                                            " + _vm._s(item.name) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driver",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver is a required field")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Schedule Time")]), _vm._v(" "), _c('datetime', {
    staticClass: "theme-wm",
    attrs: {
      "required": "",
      "id": "scheduleTime",
      "type": "datetime",
      "min-datetime": new Date().toISOString(),
      "lang": "en",
      "name": "scheduleTime",
      "input-class": "form-control",
      "placeholder": "Select Time"
    },
    on: {
      "input": function($event) {
        _vm.selectDateEnable($event)
      }
    },
    model: {
      value: (_vm.trip.scheduleTime),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleTime", $$v)
      },
      expression: "trip.scheduleTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start date is a required field")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [(_vm.$route.params && _vm.$route.params._id == '0') ? _c('a', [_c('router-link', {
    attrs: {
      "to": {
        name: 'secondaryTrip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                    Cancel\n                                ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id && _vm.$route.params._id != '0') ? _c('a', [_c('router-link', {
    attrs: {
      "to": {
        name: 'secondary',
        params: {
          _id: _vm.$route.params._id
        },
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                    Cancel\n                                ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id == '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid) && _vm.selectDate
    },
    on: {
      "click": _vm.createTrip
    }
  }, [_vm._v("\n                            Save\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id && _vm.$route.params._id != '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid) && _vm.selectDate
    },
    on: {
      "click": _vm.updateTrip
    }
  }, [_vm._v("\n                            Update\n                        ")]) : _vm._e()])], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68dd2ef8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68dd2ef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/secondaryTrip/createSecondaryTrip.vue
// module id = 2334
// module chunks = 0